



















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IMeta } from "@/interfaces";
import { PaginationNavigationButton, PaginationPageInput, PaginationSearchButton } from "@/components/utils/pagination";

@Component({
  components: {
    PaginationNavigationButton,
    PaginationPageInput,
    PaginationSearchButton,
  },
})
export default class Pagination extends Vue {
  @Prop({ required: true }) public meta: IMeta;
  @Prop({ required: true }) public currentPage: number;

  private pageInputVisible = false;
  private mobileView = false;

  get showPageInput() {
    return this.pageInputVisible;
  }

  get buttonCount() {
    return this.currentPage < 100 ? 7 : 5;
  }

  get pageCount() {
    return this.meta.pageCount;
  }

  get next() {
    return this.meta.next;
  }

  get previous() {
    return this.meta.previous;
  }

  get self() {
    return this.meta.self;
  }

  get first() {
    return this.meta.first;
  }

  get last() {
    return this.meta.last;
  }

  get showFirst() {
    return (
      (this.first !== this.previous && !this.pageButtons.includes(1)) || (this.first !== this.self && this.isMobile)
    );
  }

  get showPrevious() {
    return this.currentPage > 1;
  }

  get showNext() {
    return this.currentPage < this.pageCount;
  }

  get showLast() {
    return (
      (this.last !== this.next && !this.pageButtons.includes(this.pageCount)) ||
      (this.last !== this.self && this.isMobile)
    );
  }

  get subRangeLength() {
    return Math.floor(this.buttonCount / 2);
  }

  get pageButtons() {
    let buttons;

    if (this.pageCount <= this.buttonCount) {
      buttons = Array.apply(null, Array(this.pageCount)).map((_, i) => i + 1);
    } else if (this.currentPage <= this.subRangeLength + 1) {
      buttons = Array.apply(null, Array(this.buttonCount)).map((_, i) => i + 1);
    } else if (this.currentPage >= this.pageCount - this.subRangeLength) {
      buttons = Array.apply(null, Array(this.buttonCount)).map((_, i) => {
        return this.pageCount - this.buttonCount + i + 1;
      });
    } else {
      buttons = Array.apply(null, Array(this.buttonCount)).map((_, i) => {
        return this.currentPage - this.subRangeLength + i;
      });
    }

    return buttons;
  }

  get isMobile() {
    return this.mobileView;
  }

  public mounted() {
    const WIDTH_THRESHOLD = 768;
    const widthQuery = window.matchMedia(`(max-width: ${WIDTH_THRESHOLD}px)`);

    widthQuery.addListener((e) => this.setMobileView(e.matches));

    this.setMobileView(window.innerWidth < WIDTH_THRESHOLD);
  }

  private emitFirst() {
    this.emitPageChange(1);
  }

  private emitPrevious() {
    this.emitPageChange(this.currentPage - 1);
  }

  private emitNext() {
    this.emitPageChange(this.currentPage + 1);
  }

  private emitLast() {
    this.emitPageChange(this.pageCount);
  }

  private emitPageChange(page: number) {
    this.$emit("page-change", page);
  }

  private openPageInput() {
    this.pageInputVisible = true;
  }

  private closePageInput() {
    this.pageInputVisible = false;
  }

  private setMobileView(isMobile: boolean) {
    this.mobileView = !!isMobile;
  }
}
